import React, { useEffect, useState, useContext } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar';
import { UserContext } from './UserContext';
import * as XLSX from 'xlsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PurchaseOrderReportNew = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const formatDate = (data) => {
  if (data) {
    let msDate = data;
    let timestamp = parseInt(msDate.match(/\d+/)[0], 10);
    let date = new Date(timestamp);

    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let year = date.getFullYear(); // full year

    return `${day}-${month}-${year}`;
  } else {
    return "";
  }
};

  const { userData } = useContext(UserContext);
  const [prData, setPrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedFromDate, setSelectedFromDate] = useState(new Date());
  const [selectedToDate, setSelectedToDate] = useState(new Date());

  // Inside the component, after state declarations
  const exportToExcel = () => {
    if (!filtered || filtered.length === 0) {
      alert("No data to export");
      return;
    }

    const excelData = filtered.map((row, index) => ({
      '#': (currentPage - 1) * rowsPerPage + index + 1,
      'Purchase Order': row.PoText,
      'Supplier': row.SuppName,
      'Status': row.Status,
      'Approval Status': row.ApprovalStatus,
      'Approver': row.Approver,
      'Purchase Order Date': formatDate(row.PurchaseOrderDate),
      'Net Order Value': row.NetAmount,
      'ATTACHMENT UPLOADED?': row.YY1_ATTACH_UPLOADED_PDH,
      'Created By': row.CreatedByUser,
      'Created On': formatDate(row.CreationDate),
      'Material': row.Material,
      'Our Reference': row.CorrespncInternalReference,
      'Plant': row.Plant,
      'Pur_Req_Date': formatDate(row.YY1_Pur_Req_Date_PDH),
      'Pur_Req_No': row.YY1_Pur_Req_No_PDH,
      'Quotation Date': formatDate(row.YY1_QuotationDate_PDH),
      'Quotation No': row.YY1_QuotationNo_PDH,
      'Your Reference': row.CorrespncExternalReference,
      'Amendment PO': row.AmendmentPO,
      'Amendment Price': row.YY1_AmPOPrice_PDI,
      'Previous Payment': row.PreviousPayment,
      'Outstanding': row.Outstanding,
      'Credit': row.PaymentTerms,
      'Advance Payment': row.AdvancePayment,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = { font: { bold: true } };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PR Report');

    const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
    XLSX.writeFile(workbook, `PR_Report_${ts}.xlsx`);
  };

  const searchRecords = async () => {
    setLoading(true);
    try {
      let fromDate = new Date(selectedFromDate).toLocaleDateString("en-GB").replace(/\//g, "-");
      let toDate = new Date(selectedToDate).toLocaleDateString("en-GB").replace(/\//g, "-");
      const response = await axios.get(baseUrl + "auth/fetch-po", {
        params: {
          user_id: userId,
          fromDate: fromDate,
          toDate: toDate
        },
        ...config
      });
      //console.log(response); return false;
      //const data = response.data?.data || [];
      const data = response.data?.data.filter((item) => item.Approver==="Dr. SOUMYA RANJAN SAMAL") || [];
      //console.log(data);
      setPrData(data);
    } catch (error) {
      //console.log(error.response.data.error);
      if (error.response.data.error === "login_required" && error.response.data.login_url) {
        //console.log("here"); return false;
        //window.location.href = error.response.data.login_url;
        //console.log(data.login_url);
      }
      else {
        setPrData([]);
      }
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  useEffect(() => {
    const lower = searchText.toLowerCase();
    const filteredData = prData.filter(pr => {
      const prName = pr.PurchaseRequisition?.toLowerCase() || '';
      const prType = pr.PurchaseRequisitionType?.toLowerCase() || '';
      const desc = pr.PurReqnDescription?.toLowerCase() || '';
      return (
        prName.includes(lower) ||
        prType.includes(lower) ||
        desc.includes(lower)
      );
    });

    setFiltered(filteredData);
  }, [searchText, prData]);

  const columns = [
    {
      name: '#',
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      width: '60px',
    },
    { name: 'Purchase Order', selector: row => row.PoText, sortable: true },
    { name: 'Supplier', selector: row => row.SuppName },
    { name: 'Status', selector: row => row.Status },
    { name: 'Approval Status', selector: row => row.ApprovalStatus },
    { name: 'Approver', selector: row => row.Approver },
    { name: 'Purchase Order Date', selector: row => formatDate(row.PurchaseOrderDate) },
    { name: 'Net Order Value', selector: row => row.NetAmount },
    { name: 'ATTACHMENT UPLOADED?', selector: row => row.YY1_ATTACH_UPLOADED_PDH },
    { name: 'Created By', selector: row => row.CreatedByUser },
    { name: 'Created On', selector: row => formatDate(row.CreationDate) },
    { name: 'Material', selector: row => row.Material },
    { name: 'Our Reference', selector: row => row.CorrespncInternalReference },
    { name: 'Plant', selector: row => row.Plant },
    { name: 'Pur_Req_Date', selector: row => formatDate(row.YY1_Pur_Req_Date_PDH) },
    { name: 'Pur_Req_No', selector: row => row.YY1_Pur_Req_No_PDH },
    { name: 'Quotation Date', selector: row => formatDate(row.YY1_QuotationDate_PDH) },
    { name: 'Quotation No', selector: row => row.YY1_QuotationNo_PDH },
    { name: 'Your Reference', selector: row => row.CorrespncExternalReference },
    { name: 'Amendment PO', selector: row => row.AmendmentPO },
    { name: 'Amendment Price', selector: row => row.YY1_AmPOPrice_PDI },
    { name: 'Previous Payment', selector: row => row.PreviousPayment },
    { name: 'Outstanding', selector: row => row.Outstanding },
    { name: 'Credit', selector: row => row.PaymentTerms },
    { name: 'Advance Payment', selector: row => row.AdvancePayment },
    /*{
      name: 'Actions',
      cell: row => (
        <button
          onClick={() => navigate(`/projectdetails/${row.PurchaseRequisition}`)}
          style={{
            padding: '5px 10px',
            border: 'none',
            background: '#007bff',
            color: '#fff',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          View Details
        </button>
      )
    }*/
  ];

  return (
    <>
      <Topbar />
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row page-titles">
            <div className="col-md-5 align-self-center">
              <h4 className="text-themecolor">Purchase Order Report</h4>
            </div>
            <div className="col-md-7 align-self-center text-end">
              <div className="d-flex justify-content-end align-items-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                  <li className="breadcrumb-item active">Purchase Order Report</li>
                </ol>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div /*style={{ textAlign: 'center', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}*/>
                    <DatePicker
                      selected={selectedFromDate}
                      onChange={(date) => setSelectedFromDate(date)}
                      dateFormat="dd/MM/yyyy"
                      style={{
                        width: '30%',
                        padding: '10px',
                        fontSize: '16px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                        marginRight: '24px'
                      }}
                    />

                    <DatePicker
                      selected={selectedToDate}
                      onChange={(date) => setSelectedToDate(date)}
                      dateFormat="dd/MM/yyyy"
                      style={{
                        width: '30%',
                        padding: '10px',
                        fontSize: '16px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                      }}
                    />

                    <button
                      onClick={searchRecords}
                      style={{
                        padding: '10px 15px',
                        background: '#28a745',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        marginRight: '24px'
                      }}
                    >
                      Search
                    </button>

                    <button
                      onClick={exportToExcel}
                      style={{
                        padding: '10px 15px',
                        background: '#28a745',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                    >
                      Export to Excel
                    </button>
                  </div>


                  <DataTable
                    columns={columns}
                    data={filtered}
                    pagination
                    paginationServer={false}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={filtered.length}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={loading}
                    progressComponent={<div style={{color:"Green", fontSize: "35px"}}>Loading Purchase Order....</div>}
                    highlightOnHover
                    persistTableHead
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right sidebar left as-is */}
        </div>
      </div>
    </>
  );
};

export default PurchaseOrderReportNew;
